import { writable } from "svelte/store";
import { Authenticator } from "./authentication/Authenticator";
import { WebStorageStateStore } from "oidc-client";
import { Api } from "./api/Api";
export class AppManager {
    constructor() {
        this.ModalHooks = {};
        /**
         * True when we assumed a small screen.
         */
        this.isSmall = writable(true);
    }
    initialize(settings, apiSettings) {
        let publicUrl = settings.publicUrl.href;
        let rootUrl = settings.publicUrl.origin;
        if (publicUrl.endsWith("/"))
            publicUrl = publicUrl.substring(0, publicUrl.length - 1);
        if (rootUrl.endsWith("/"))
            rootUrl = rootUrl.substring(0, rootUrl.length - 1);
        this.authenticator = new Authenticator({
            authority: "process.env.AUTHORITY",
            client_id: "website-webapp",
            redirect_uri: `${publicUrl}/callback`,
            post_logout_redirect_uri: `${publicUrl}`,
            silent_redirect_uri: `${publicUrl}/silent`,
            response_type: "code",
            scope: "openid profile impact roles identity shortcut",
            automaticSilentRenew: true,
            monitorSession: false,
            checkSessionInterval: 2000,
            userStore: new WebStorageStateStore({
                prefix: "anyways",
                store: window.localStorage,
            }),
        });
        this.PublicUrl = publicUrl;
        this.RootUrl = rootUrl;
        this.api = new Api(this.authenticator, apiSettings);
    }
    /**
     * Checks if the user is signed in.
     * @returns True if a user is signed in, false otherwise.
     */
    async isSignedIn() {
        return this.authenticator.isSignedIn();
    }
    /**
     * Start sign in.
     * @param url The url to redirect to once signed in.
     */
    async startSignin(url) {
        await this.authenticator.startSignin(url);
    }
    /**
     * Logs the current user out.
     */
    async logout() {
        await this.authenticator.logout();
    }
    /**
     * Completes a signin using a redirect callback.
     * @returns the url to redirect to
     */
    async completeSignin() {
        return await this.authenticator.completeSignin();
    }
    /**
     * Completes a signin using a silent callback.
     */
    async completeSigninSilent() {
        return await this.authenticator.signinSilentCallback();
    }
    /**
     * Completes a silent signin.
     * @returns
     */
    async signinSilentCallback() {
        return await this.authenticator.signinSilentCallback();
    }
}
export const appManager = new AppManager();
